import {apiClient} from './apiClient';

export interface LogoItem {
  id: string;
  url: string;
  code: string;
}

export const logosApi = {
  getLogos: async (): Promise<LogoItem[]> => {
    try {
      const response = await apiClient.get<LogoItem[]>('/lists/logos');
      if (Array.isArray(response.data)) {
        return response.data;
      }
      console.warn('Logo endpoint returned unexpected payload');
      return [];
    } catch (error) {
      console.error('Error fetching logos', error);
      return [];
    }
  },
};
